var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUnofficialPlan(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 87,
    viewBox: "0 0 70 87",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_103_73)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M54.5886 4.85852H0V87H64.167V14.4369L54.5886 4.85852Z",
    fill: "#50C1DC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.7301 0H5.60663V82.1323H69.7736V20.0435L49.7301 0Z",
    fill: "#CBEAF2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.7519 27.673H18.4456V31.6078H59.7519V27.673Z",
    fill: "#243A78"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.7519 38.8309H18.4456V42.7657H59.7519V38.8309Z",
    fill: "#243A78"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.7519 49.9888H18.4456V53.9236H59.7519V49.9888Z",
    fill: "#243A78"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.7301 0L69.7736 20.0435H49.7301V0Z",
    fill: "#50C1DC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.7301 20.0436L69.7736 27.673V20.0436H49.7301Z",
    fill: "#A6D0D7"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_103_73"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 69.7737,
    height: 87,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnofficialPlan);
export default __webpack_public_path__ + "static/media/unofficial_plan.b3f1ff4a9665c00a84b0d5eded2f71fc.svg";
export { ForwardRef as ReactComponent };